import axios from 'axios'
import API from '@/common/api'
import store from '..'
import moment from 'moment'

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
  },
  actions: {
    setCouponList ({ state }, data) {
      state.list = data.map(x => {
        const isExpired = (data) => {
          return (data.payload && data.payload.useTerm !== true) &&
            moment().isSameOrBefore(moment(data.useBefore, 'day'))
        }
        return {
          ...x,
          expired: isExpired(x)
        }
      })
    },
    setWaitCoupon ({ state, dispatch }, data) {
      const siteid = store.state.authentication.site
      localStorage.setItem(`${siteid}_coupon_iids`, JSON.stringify(data))
    },
    getWaitCoupon ({ state, dispatch }) {
      const siteid = store.state.authentication.site
      const storage = localStorage.getItem(`${siteid}_coupon_iids`)
      const iids = storage && JSON.parse(storage) ? JSON.parse(storage).iids : null
      const returnURL = storage && JSON.parse(storage) ? JSON.parse(storage).returnURL : null
      function getUrl (url) {
        const result = url ? new URL(url) : false
        const hash = result && result.hash
        return hash && hash.replace('#/', '').split('/').filter((x, i) => i > 0).join('/')
      }
      return returnURL && getUrl(returnURL) === getUrl(window.location.href) ? iids : false
    },
    delWaitCoupon ({ state, dispatch }) {
      const siteid = store.state.authentication.site
      localStorage.removeItem(`${siteid}_coupon_iids`)
    },
    checkCoupon ({ state, dispatch }, couponIds) { // 페이지 전송에 쿠폰이 있는지 확인
      if (couponIds && couponIds.length) {
        return Promise.all(couponIds.map(x => dispatch('useCoupon', { iid: x }))).then((res) => {
          return res
        })
      }
    },
    async useCoupons ({ state, dispatch }, data) {
      const locale = store.state.system.locale.data
      return dispatch('checkCoupon', data).then((res) => {
        if (res && res.length && res.includes(false)) {
          alert(`${locale.alert_use_coupon_disabled}\n${locale.ask_front}`)
        }
        dispatch('delWaitCoupon')
        return res
      })
    },
    async getCoupon ({ dispatch }) {
      const authentication = store.state.authentication
      const hasOid = !!authentication.oid && authentication.oid !== 'undefined' && authentication.oid !== 'na'
      const roomKey = authentication.public ? await store.dispatch('authentication/getOtaKey') : store.state.authentication.k
      const key = roomKey ? `spaceid=${authentication.space}&k=${authentication.k}` : hasOid ? `oid=${authentication.oid}` : null
      /**
       * pms 연동으로 넘어온 커스텀쿠폰은
       * 실시간으로 iid를 생성하기 때문에
       * 쿠폰 사용하는 프로세스 내에서 여러번 조회할 때
       * 동일한 쿠폰을 찾을 수 없다.
       * iid는 originIid로 저장하고 (가장 마지막 서버에 전송할 때 사용)
       * => 커스텀쿠폰 이름에 인덱스를 달아 임시 iid로 사용 (getCustomIndex())
       */
      function getCustomName (iid) {
        // custom^test^aa9^001^PIZZA2^2022-09-01^20220901^410^fbc7c8f8-1409-41e1-bc9d-b216613fd95a
        iid = decodeURIComponent(iid).split('^')
        return iid.filter((x, i) => i < iid.length - 1).join('_')
      }
      return axios.get(`${API.BASE_URL}/castit/file?cmd=get-my-coupon&siteid=${API.SITE_INFO.site}&${key}`).then(res => {
        const couponList = res && res.data && res.data.message ? res.data.message.sort(function (a, b) {
          return a.createat > b.createat ? -1 : a.createat < b.createat ? 1 : 0
        }).map(x => {
          const isCustom = x.iid.startsWith('custom')
          const iid = isCustom ? getCustomName(x.iid) : x.iid
          return {
            ...x,
            iid: iid,
            ...isCustom && {
              iidOrigin: x.iid
            }
          }
        }) : []
        const coupons = getCustomIndex(couponList)
        function getCustomIndex (couponList) {
          const customCnt = {}
          for (let i = 0; i < couponList.length; i++) {
            const coupon = couponList[i]
            if (coupon.iid.startsWith('custom')) {
              const couponName = coupon.iid
              if (customCnt[couponName]) {
                customCnt[couponName] += 1
              } else {
                customCnt[couponName] = 0
              }
              coupon.iid = `${couponName}_${customCnt[couponName]}`
            }
          }
          return couponList
        }
        dispatch('setCouponList', coupons)
        return coupons
      }).catch((ex) => {
        // console.log(ex.response.data)
        return ex.response.data
      })
    },
    async useCoupon ({ dispatch }, data) {
      return axios.get(`${API.BASE_URL}/castit/file?cmd=use-coupon&iid=${data.iid}`).then(res => {
        return res.data && res.data.message && res.data.message === 'ok' && true
      }).catch((ex) => {
        return false
      })
    }
  },
  getters: {
    getCoupon: state => {
      return state.list
    }
  }
}
